export default ({ request }) => ({
  fabricRequestListApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/request/list',
      method: 'post',
      data,
    })
  },
  fabricRequestDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/request/detail',
      method: 'post',
      data,
    })
  },
  fabricRequestSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/request/save',
      method: 'post',
      data,
    })
  },
  fabricRequestDelApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/request/del',
      method: 'post',
      data,
    })
  },
  fabricRequestOaDevelopApplyApi(data = {}) {
    return request({
      url: '/oa/fabric/request/developApply',
      method: 'post',
      data,
    })
  },
  fabricRequestColorListApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/request/color/list',
      method: 'post',
      data,
    })
  },
  fabricRequestBuilderApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/request/builder',
      method: 'post',
      data,
    })
  },
  fabricRequestNotInStockApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/request/notInStock',
      method: 'post',
      data,
    })
  },
  fabricRequestH5ViewDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/opa/fabric/request/detail',
      method: 'post',
      data,
    })
  },
  fabricRequestListBySummaryApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/request/listBySummary',
      method: 'post',
      data,
    })
  },
  fabricRequestCalcRequestMetreApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/request/calcRequestMetre',
      method: 'post',
      data,
    })
  },
})
